import React from 'react';
import styled from 'styled-components';

import { LayoutColors } from '@src/core/theme';
import { SaleItem } from '@src/core/buyerApiClient';
import { BodySmallMedium } from '@src/fonts/typography/Typography';

import { SaleDate } from '../shared';
import { device } from '@src/common/breakpoints';
import { formatMinutes } from '@src/common';

type ReservationsProps = {
  saleItems: SaleItem[];
};

const Reservations = ({ saleItems }: ReservationsProps) => {
  const HIGHLIGHTED_SALE_RESERVATIONS_TO_DISPLAY = 3;
  const reservationsToDisplay = saleItems.slice(0, HIGHLIGHTED_SALE_RESERVATIONS_TO_DISPLAY);
  const hiddenReservationsQuantity = saleItems.length - reservationsToDisplay.length;

  return (
    <ShoppingItems>
      {reservationsToDisplay.map((saleItem) => {
        return (
          <Item key={saleItem.id}>
            <p>{saleItem.product.name}</p>
            <div>
              <SaleDate
                scheduleDate={saleItem.scheduleDate}
                scheduleTimeMinutes={
                  saleItem.scheduleTimeMinutes != null ? formatMinutes(saleItem.scheduleTimeMinutes) : null
                }
              />
            </div>
          </Item>
        );
      })}
      {hiddenReservationsQuantity > 0 ? <HiddenItems>+{hiddenReservationsQuantity}</HiddenItems> : null}
    </ShoppingItems>
  );
};

export default Reservations;

const ShoppingItems = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 8px;

  ${device.smallTablet} {
    flex-direction: row;
    justify-content: flex-start;
  }
`;

const Item = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  border: 1px solid ${LayoutColors.blackLight};
  border-radius: 4px;
  width: 100%;
  max-width: 100%;
  padding: 8px;

  ${device.smallTablet} {
    flex-direction: column;
    padding: 16px;
    width: 178px;
  }

  p {
    width: 140px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    word-break: keep-all !important;
  }

  p,
  span {
    ${BodySmallMedium};
    color: ${LayoutColors.blackMain};
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const HiddenItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 100%;

  ${device.smallTablet} {
    max-width: 80px;
  }

  ${BodySmallMedium};
  color: ${LayoutColors.grayMain};
  border: 1px solid ${LayoutColors.grayMain};
  border-radius: 4px;
`;
